import { ExportOutlined } from '@ant-design/icons';
import { List } from 'antd';
import React from 'react';
import {
  StyledDrawer,
  StyledList,
  StyledListItem,
  StyledTitle,
} from './styled';

const DocumentationDrawer = ({ open, setOpen }) => {
  const onClose = () => {
    setOpen(false);
  };

  // Documentation des différentes pages du site
  const documentationData = [
    {
      title: 'Dashboard',
      description: "Page d'accueil du tableau de bord",
      link: 'http://wiki.hoortrade.local/',
    },
    {
      title: 'Catalogue - Produits bruts',
      description: 'Gestion des produits bruts du catalogue',
      link: 'http://wiki.hoortrade.local/',
    },
    {
      title: 'Catalogue - Produits marketplace',
      description: 'Gestion des produits destinés aux marketplaces',
      link: 'http://wiki.hoortrade.local/',
    },
    {
      title: 'Marketplaces',
      description: "Vue d'ensemble des marketplaces connectées",
      link: 'http://wiki.hoortrade.local/',
    },
    {
      title: 'Marketplaces - Leroy Merlin - Catégories',
      description: 'Gestion des catégories Leroy Merlin',
      link: 'http://wiki.hoortrade.local/',
    },
    {
      title: 'Catégories brutes',
      description: 'Gestion des catégories de produits brutes',
      link: 'http://wiki.hoortrade.local/',
    },
    {
      title: 'Mapping',
      description: 'Correspondance entre catégories et attributs',
      link: 'http://wiki.hoortrade.local/',
    },
    {
      title: 'Attributs',
      description: 'Gestion des attributs produits',
      link: 'http://wiki.hoortrade.local/',
    },
  ];

  return (
    <StyledDrawer
      title={<StyledTitle level={4}>Documentation</StyledTitle>}
      placement="right"
      closable={true}
      onClose={onClose}
      open={open}
      getContainer={false}
    >
      <StyledList
        dataSource={documentationData}
        renderItem={(item) => (
          <StyledListItem>
            <a
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                width: '100%',
                textDecoration: 'none',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <List.Item.Meta
                title={item.title}
                description={item.description}
              />
              <ExportOutlined
                style={{
                  fontSize: '16px',
                  color: '#1890ff',
                  marginLeft: '12px',
                  flexShrink: 0,
                }}
              />
            </a>
          </StyledListItem>
        )}
      />
    </StyledDrawer>
  );
};

export default DocumentationDrawer;
